import './InfoBlock.scss';

import classNames from 'classnames';

export function InfoBlock({ children, custom }) {
  return (
    <div className={classNames('info-block', custom && 'info-block--custom')}>
      {children}
    </div>
  );
}
